var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"autofocus":"","type":"text","label":"Group Code"},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})}
var staticRenderFns = []

export { render, staticRenderFns }